import { BaseModel } from "./base.model";

export class PullProductCreateModel  {
    materialTypeId: string;
    invoiceDate: string;
}